import * as React from 'react';
import { styled } from '@mui/material/styles';
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Acordion from '../AdminEdit/AdmGeneradorReporte';
import { mapStateToProps } from '../models/buscar';
import BorderColorIcon from '@mui/icons-material/BorderColor';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


function AdminGeneradorReportePage(props) {


  return (

    <div
      style={{
        height: '100%',
        display: "flex",
        width: '100%',
        backgroundColor: "#f6f6f6",
        borderTopLeftRadius: 20,
        borderTopRightRadius: 20,
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div style={{ flexDirection: 'row', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
        <BorderColorIcon style={{ marginLeft: 10, marginBottom: 10, color: 'rgba(229, 29, 29, 0.7)' }} /><h3 style={{ color: 'rgba(229, 29, 29, 0.7)', alignSelf: 'flex-start', marginLeft: 15, marginBottom: 10 }}>
          Panel de administrador
        </h3>
      </div>

      <div
        style={{
          height: 'auto',
          display: "flex",
          width: '100%',
          backgroundColor: 'rgba(238, 238, 238, 0.9)',
          marginTop: 10,
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          padding: 10,
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Box sx={{ flexGrow: 1, width: '100%', height: '100%', }}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={10}>
              <Item>
                <div style={{
                  height: 50, display: 'flex', alignItems: 'center', justifyContent: 'flex-start', alignContent: 'center',
                  borderTopLeftRadius: 5, borderTopRightRadius: 5, paddingLeft: 20
                }}>
                  <h4 >Secciones editables</h4>
                </div>
                <Acordion />
                <div style={{
                  height: 'auto', display: 'flex', alignItems: 'center', justifyContent: 'flex-start', alignContent: 'center',
                  borderTopLeftRadius: 5, borderTopRightRadius: 5, paddingLeft: 20, paddingTop: 20
                }}>
                </div>
              </Item>
            </Grid>


          </Grid>
        </Box>


      </div>

    </div >
  );
}

export default connect(mapStateToProps, null)(AdminGeneradorReportePage);